import { render, staticRenderFns } from "./updateAuth.vue?vue&type=template&id=95ae01a8&scoped=true&"
import script from "./updateAuth.vue?vue&type=script&lang=js&"
export * from "./updateAuth.vue?vue&type=script&lang=js&"
import style0 from "./updateAuth.vue?vue&type=style&index=0&id=95ae01a8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ae01a8",
  null
  
)

export default component.exports